var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("m-table-settings-positions", {
        attrs: {
          "is-grouped": _vm.tableData.isGroupByCategory,
          columns: _vm.tableData.columns,
          "disabled-columns": _vm.tableData.disabledColumns,
          "default-disabled-columns": _vm.tableData.defaultDisabledColumns,
          "is-driver-table-settings": _vm.codeGroup === "driver",
          "with-grouped": "",
        },
        on: { submit: _vm.submitTableSettings },
        model: {
          value: _vm.isShowTableSettingsModal,
          callback: function ($$v) {
            _vm.isShowTableSettingsModal = $$v
          },
          expression: "isShowTableSettingsModal",
        },
      }),
      _c("div", { staticClass: "positions-production" }, [
        _c("div", { staticClass: "positions-production__wrapper" }, [
          _c(
            "div",
            { staticClass: "positions-production__actions" },
            [
              _c("c-switcher", {
                staticClass: "h-switcher",
                attrs: { type: "group", items: _vm.positionStatuses },
                model: {
                  value: _vm.selectedPositionStatus,
                  callback: function ($$v) {
                    _vm.selectedPositionStatus = $$v
                  },
                  expression: "selectedPositionStatus",
                },
              }),
              _c(
                "div",
                { staticClass: "positions-production__actions__buttons-block" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "positions-production__actions__buttons-block-item",
                    },
                    [
                      _c("c-button", {
                        attrs: {
                          responsive: "",
                          disabled:
                            _vm.isTableLoad ||
                            _vm.tableData.activeFilteredColumns.length === 0,
                          label: "Сбросить фильтры столбцов",
                          icon: { color: "pink", icon: "filter-drop" },
                          type: "with-icon",
                        },
                        on: { click: _vm.resetColumnFilters },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "positions-production__actions__buttons-block-item",
                    },
                    [
                      _c("c-button", {
                        attrs: {
                          disabled: _vm.shouldDisableSettingsButton,
                          responsive: "",
                          label: "Настроить столбцы",
                          icon: "cog",
                          type: "with-icon",
                        },
                        on: {
                          click: function ($event) {
                            _vm.isShowTableSettingsModal = true
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "positions-production__table" },
            [
              _vm.isTableLoad
                ? _c("c-loader", {
                    attrs: {
                      label: "Загрузка данных",
                      active: _vm.isTableLoad,
                      height: "300",
                    },
                  })
                : _vm._e(),
              !_vm.isTableLoad
                ? _c("c-data-table-positions", {
                    ref: "table",
                    staticClass: "positions-production-table",
                    class: {
                      "positions-production__table-empty":
                        _vm.tableData.columns.length === 0 &&
                        _vm.tableData.records.length === 0,
                    },
                    attrs: {
                      "empty-records-label": "Должности не найдены",
                      data: _vm.tableData,
                      "sorted-column": _vm.tableData.sortedColumn,
                      "disabled-columns": _vm.tableData.disabledColumns,
                      "filtered-columns": _vm.tableData.filteredColumns,
                      "active-filtered-columns":
                        _vm.tableData.activeFilteredColumns,
                      "all-groups": _vm.allGroups,
                      levels: 1,
                      "reference-list": _vm.referenceFilterList,
                    },
                    on: {
                      sortedEvent: _vm.sortedTableAction,
                      getReferenceValues: _vm.setColumnReferenceFilterList,
                      removePost: _vm.removePost,
                      changeArchiveStatus: _vm.changeArchiveStatus,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }